var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task",
    transform: "translate(-7.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13387",
    "data-name": "Path 13387",
    d: "M22.045,5.143H19.864V4.429A1.442,1.442,0,0,0,18.409,3H12.591a1.442,1.442,0,0,0-1.455,1.429v.714H8.955A1.442,1.442,0,0,0,7.5,6.571v15A1.442,1.442,0,0,0,8.955,23H22.045A1.442,1.442,0,0,0,23.5,21.571v-15A1.442,1.442,0,0,0,22.045,5.143Zm-9.455-.714h5.818V7.286H12.591Zm9.455,17.143H8.955v-15h2.182V8.714h8.727V6.571h2.182Z",
    transform: "translate(0)",
    fill: "#6249ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskActive);
export default __webpack_public_path__ + "static/media/taskActive.7d370a4539fd72d33a6e243ac26e8299.svg";
export { ForwardRef as ReactComponent };